<template>
  <div class="detail-navigation d-flex align-items-center" v-if="hasNavigation">
    <button
      @click="navigatePrevious"
      class="btn btn-sm me-2"
      :class="buttonClass"
      :disabled="!hasPrevious"
      title="Vorige">
      <i class="bi bi-chevron-left"></i>
    </button>

    <span class="navigation-info small text-muted">
      {{ position.current }} van {{ position.total }}
    </span>

    <button
      @click="navigateNext"
      class="btn btn-sm ms-2"
      :class="buttonClass"
      :disabled="!hasNext"
      title="Volgende">
      <i class="bi bi-chevron-right"></i>
    </button>

    <button
      @click="backToOverview"
      class="btn btn-sm ms-2"
      :class="buttonClass"
      title="Terug naar overzicht">
      <i class="bi bi-list-ul"></i>
    </button>
  </div>
</template>

<script>
import NavigationService from '../services/NavigationService';

export default {
  name: 'DetailNavigation',
  props: {
    itemType: {
      type: String,
      default: 'order',
      validator: (value) => ['order', 'invoice', 'orderConfirmation'].includes(value)
    },
    buttonClass: {
      type: String,
      default: 'btn-secondary'
    }
  },
  data() {
    return {
      hasPrevious: false,
      hasNext: false,
      position: { current: 0, total: 0, listRouteName: '' },
      hasNavigation: false
    }
  },
  methods: {
    updateNavigationState() {
      this.hasPrevious = NavigationService.hasPrevious(this.itemType);
      this.hasNext = NavigationService.hasNext(this.itemType);
      this.position = NavigationService.getPosition(this.itemType);
      this.hasNavigation = this.position.total > 0;
    },
    navigatePrevious() {
      const result = NavigationService.getPreviousItem(this.itemType);
      if (result) {
        // Forceer eerst pagina-update door component direct aan te roepen
        this.$emit('navigate', result.item.id);
        
        // Dan navigeren we naar de nieuwe pagina
        // Met een kleine vertraging om ervoor te zorgen dat de event handler wordt uitgevoerd
        setTimeout(() => {
          const routeData = {
            name: this.$route.name,
            params: { ...this.$route.params, id: result.item.id },
            // Force component reload met random query parameter
            query: { ...this.$route.query, _refresh: Date.now() } 
          };
          
          // Navigeer naar de nieuwe route
          this.$router.push(routeData);
        }, 10);
      }
    },
    navigateNext() {
      const result = NavigationService.getNextItem(this.itemType);
      if (result) {
        // Forceer eerst pagina-update door component direct aan te roepen
        this.$emit('navigate', result.item.id);
        
        // Dan navigeren we naar de nieuwe pagina
        // Met een kleine vertraging om ervoor te zorgen dat de event handler wordt uitgevoerd
        setTimeout(() => {
          const routeData = {
            name: this.$route.name,
            params: { ...this.$route.params, id: result.item.id },
            // Force component reload met random query parameter
            query: { ...this.$route.query, _refresh: Date.now() }
          };
          
          // Navigeer naar de nieuwe route
          this.$router.push(routeData);
        }, 10);
      }
    },
    backToOverview() {
      // Ga terug naar de overzichtspagina
      try {
        // direct naar de hoofdpagina
        this.$router.push(this.getDefaultListRoute());
      } catch (error) {
        console.error('Navigatiefout:', error);
        // Absolute fallback: direct naar de hoofdpagina via window.location
        window.location.href = this.getDefaultListRoute();
      }
    },
    /**
     * Bepaalt het standaard pad voor de lijst op basis van het itemtype
     * @returns {String} Het pad naar de lijstpagina
     */
    getDefaultListRoute() {
      const pathMap = {
        'order': '/orders',
        'invoice': '/invoices',
        'orderConfirmation': '/orderBevestigingen'
      };
      return pathMap[this.itemType] || '/';
    }
  },
  mounted() {
    this.updateNavigationState();
  },
  // Als de route parameters veranderen (bijv. andere ID) maar de route blijft hetzelfde
  watch: {
    '$route': {
      handler() {
        this.updateNavigationState();
      },
      deep: true
    }
  }
}
</script>

<style scoped>
.detail-navigation {
  display: flex;
  justify-content: center;
  padding: 0.5 rem 0;
}

.navigation-info {
  min-width: 80px;
  text-align: center;
}
</style>
